var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.739 10.548C1.845 10.464 1.094 9.81.97 8.922a22.727 22.727 0 0 1 .01-6.4c.12-.83.798-1.457 1.632-1.544A42.122 42.122 0 0 1 7 .75c1.501 0 2.948.085 4.358.23a1.854 1.854 0 0 1 1.659 1.572 22.92 22.92 0 0 1 .233 3.231c0 1.096-.093 2.161-.239 3.196a1.886 1.886 0 0 1-1.686 1.605 42.688 42.688 0 0 1-4.432.232c-1.049 1.206-1.853 1.803-3.258 2.434v-2.62l-.68-.062-.216-.02Z",
    stroke: "#6A737D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.997 6.409c0-.361.294-.583.812-.93.48-.32.734-.737.62-1.304a1.488 1.488 0 0 0-1.147-1.148A1.476 1.476 0 0 0 5.536 4.46",
    stroke: "#6A737D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.996 8.488a.125.125 0 0 1 0-.25M6.996 8.488a.125.125 0 1 0 0-.25",
    stroke: "#6A737D",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatQuestion);
export default __webpack_public_path__ + "static/media/chat-question.26ee7d16.svg";
export { ForwardRef as ReactComponent };